// extracted by mini-css-extract-plugin
module.exports = {"cta":"cta___11oY9","author":"author___3otLj"};